import faqReducer, {
  INDIVIDUAL_REDUCER_KEY,
  selectIndividual,
} from './individualReducer';

export { INDIVIDUAL_REDUCER_KEY, selectIndividual };

export default faqReducer;
